import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IInterbankFastForm extends IFastPaymentForm {
  paymentAttempt: number;
  fastPaymentCheckAttempt: number;
  isPayingSelf: string;
  nric: string | undefined;
  name: string;
  relationship: string;
  reason: string;
  boReferenceNum: string;
  payerAccountHoldingBank: string;
  bank: string;
  bankList: Array<{
    id: string;
    label: string;
    status: string;
    segment: string;
  }>;
  fastErrorReason: string;
}
interface IDropDown {
  label: string;
  id: string;
}
export interface ISrsForm {
  operator: IDropDown;
  accountNum: string;
}

export interface IFastPaymentForm {}
export interface IInitialStatePaymentFormData {
  srsBankList: Array<{ id: string; label: string }>;
  paymentMethod: "" | "interbank" | "srs" | "fast" | "now";
  interbankFastForm: IInterbankFastForm;
  srsForm: ISrsForm;
  paymentRef: string;
  policyNumber: string;
  trancheStatus: string;
}

const initialState: IInitialStatePaymentFormData = {
  srsBankList: [],
  paymentMethod: "",
  interbankFastForm: {
    fastPaymentCheckAttempt: 0,
    paymentAttempt: 0,
    isPayingSelf: "",
    nric: undefined,
    name: "",
    relationship: "",
    reason: "",
    boReferenceNum: "",
    payerAccountHoldingBank: "",
    bank: "",
    bankList: [],
    fastErrorReason: "",
  },
  srsForm: {
    operator: { id: "", label: "" },
    accountNum: "",
  },
  paymentRef: "",
  policyNumber: "",
  trancheStatus: "",
};
const step4Slice = createSlice({
  name: "Ever_Green_Step_4",
  initialState,
  reducers: {
    updateSrsBankList: (
      state,
      action: PayloadAction<Array<{ id: string; label: string }>>
    ) => {
      state.srsBankList = action.payload;
    },
    updatePaymentMethod: (
      state,
      action: PayloadAction<"interbank" | "srs" | "fast" | "now">
    ) => {
      state.paymentMethod = action.payload;
    },
    updateInterbankFastForm: (
      state,
      action: PayloadAction<Partial<IInterbankFastForm>>
    ) => {
      state.interbankFastForm = {
        ...state.interbankFastForm,
        ...action.payload,
      };
    },
    updateSrsForm: (state, action: PayloadAction<Partial<ISrsForm>>) => {
      state.srsForm = {
        ...state.srsForm,
        ...action.payload,
      };
    },
    updatePaymentRef: (
      state,
      action: PayloadAction<{
        paymentRef: string;
        policyNumber: string;
        trancheStatus?: string;
        fastErrorReason?: string;
      }>
    ) => {
      state.paymentRef = action.payload.paymentRef;
      state.policyNumber = action.payload.policyNumber;
      state.trancheStatus = action.payload.trancheStatus || "";
      state.interbankFastForm.fastErrorReason =
        action.payload.fastErrorReason || "";
    },
    updateStep4ToDefault: (state, action) => ({
      ...initialState,
    }),
  },
});

export const {
  updateSrsBankList,
  updatePaymentMethod,
  updateInterbankFastForm,
  updateSrsForm,
  updateStep4ToDefault,
  updatePaymentRef,
} = step4Slice.actions;

export default step4Slice.reducer;
